export enum DocumentStatus {
  NotExist = 1,
  HasWorkingCopy,
  ActualVersion,
  Unknown,
}

export enum AvailableFilters {
  inprogress = 'IN PROGRESS',
  cancelled = 'CANCELLED',
  completed = 'COMPLETED',
}
